selectedData = null;

const showEntitySelectModal = function (divId, onSelect) {
  let div = "#" + divId;
  if ($("div.alert-alert").length) {
    // we're reloading the page with form errors - don't show the popup
    $(div).hide();
    return;
  }
  $(div).dialog({
    resizable: true,
    height: 400,
    width: 600,
    modal: true,
    buttons: {
      "None of these": function () {
        $(this).dialog("close");
      },
      Next: function () {
        $(this).dialog("close");
        if (onSelect) {
          onSelect();
        }
      },
    },
  });
};

const setupEntitySelectionHandler = function () {
  initContributionDetailsButton("data-entity-search-entity-id");
  $("a[data-selected-entity-id]").click(function (e) {
    $("#entity-search-modal").modal("hide");
    let entityId = $(this).attr("data-selected-entity-id");
    window.location.href =
      window.location.href +
      (window.location.href.indexOf("?") >= 0 ? "&" : "?") +
      "entity_id=" +
      entityId;
    e.preventDefault();
  });
};

// Make functions globally available for inline scripts
window.showEntitySelectModal = showEntitySelectModal;
window.setupEntitySelectionHandler = setupEntitySelectionHandler;
